import React from 'react'
import { Box, Typography } from '@mui/material'
import AppleLuckyDrawTable from './Table'
import Toolbar from './Toolbar'

const AppleLuckyDraw = () => (
  <Box
    mb={8}
    textAlign='center'
    boxShadow={1}
    style={{ color: '#464646', background: 'whitesmoke' }}
  >
    <Box pt={6} pb={4}>
      <Typography variant='h2' gutterBottom={true}>
        End User
      </Typography>
      <Typography variant='h1' fontWeight={900} fontSize={36}>
        Apple Products Lucky Draw
      </Typography>
    </Box>

    <Toolbar></Toolbar>
    <AppleLuckyDrawTable></AppleLuckyDrawTable>
  </Box>
)

export default AppleLuckyDraw
